import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { capitalize } from '../../../../utils/capitalize-string';
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
import styled from 'styled-components';
import { purpurColorPurple800 } from '@purpurds/tokens/color/variables';
import { formatDate } from 'utils/format-date';
const CustomerInfoItemsContainer = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 14px 14px;
  font-size: 20px;
  font-weight: 400;
  gap: 3rem;

  @media (max-width: 460px) {
    flex-direction: column;
    gap: 1rem;
  }
`;
const AddressButton = styled.button `
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  text-align: left;
  font-size: 20px;
  font-weight: 400;
  color: ${purpurColorPurple800};
`;
const AddressContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 8px;
`;
const NameContainer = styled.div `
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 50%;
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: 400;
`;
const PhoneAndDobContainer = styled.div `
  margin-left: 8px;
  line-height: 1.2;
`;
const StyledLink = styled.a `
  text-decoration: none;
  cursor: pointer;
  color: ${purpurColorPurple800};
`;
const Telephone = styled.div `
  display: flex;
  align-items: flex-end;
  letter-spacing: 0.5px;
  font-size: 22px;
  color: ${purpurColorPurple800};

  a {
    color: ${purpurColorPurple800};
    text-decoration: none;
  }
`;
const StyledIcon = styled(Icon) `
  color: ${purpurColorPurple800};
`;
export const CustomerInfoDetails = ({ address, customer, openModal, isPastDue, }) => {
    const { city, flatOrApartment, houseNumberAlpha, houseNumberNumeric, postalCode, street } = address;
    const { firstName, phoneNumber, email, surname, birthDate } = customer;
    const formatedBirthDate = formatDate(birthDate);
    return (_jsxs(CustomerInfoItemsContainer, { children: [_jsxs(AddressButton, { "$isPastDue": isPastDue, onClick: () => openModal(address), children: [_jsx(StyledIcon, { svg: icons.home, "$isPastDue": isPastDue }), _jsxs(AddressContainer, { children: [_jsx("span", { children: `${capitalize(street)} ${houseNumberNumeric}${houseNumberAlpha}, ` }), _jsx("span", { children: `${postalCode} ${capitalize(city)} ` }), flatOrApartment && _jsx("span", { children: flatOrApartment })] })] }), _jsxs(NameContainer, { children: [_jsx(StyledIcon, { svg: icons.endUser, "$isPastDue": isPastDue }), _jsxs(PhoneAndDobContainer, { children: [_jsxs("div", { children: [" ", `${capitalize(firstName)} ${capitalize(surname)}`] }), _jsx("div", { children: formatedBirthDate }), _jsx("div", { children: _jsx(StyledLink, { href: `mailto:${email}`, children: email }) }), _jsxs(Telephone, { "$isPastDue": isPastDue, children: [_jsx(StyledIcon, { svg: icons.phone, "$isPastDue": isPastDue }), _jsx(StyledLink, { href: `tel:${phoneNumber}`, children: phoneNumber })] })] })] })] }));
};
